export default __webpack_public_path__ + "static/media/VIP_pink.90ef6b1c.png";